var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.8917 22C2.1956 22 0 19.7667 0 17.023L0 11.5658C0 8.82767 2.189 6.6 4.8807 6.6L17.1083 6.6C19.8055 6.6 22 8.83326 22 11.5781V17.0331C22 19.7723 19.811 22 17.1193 22H16.0853H4.8917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4003 0.243214L7.20035 3.37358C6.87035 3.69712 6.87035 4.21777 7.20255 4.54024C7.53475 4.86163 8.07045 4.86056 8.40045 4.5381L10.1528 2.82293V4.46739V13.6967C10.1528 14.152 10.5323 14.5216 10.9998 14.5216C11.4684 14.5216 11.8468 14.152 11.8468 13.6967V2.82293L13.5991 4.5381C13.9291 4.86056 14.4648 4.86163 14.797 4.54024C14.9631 4.37847 15.0467 4.16742 15.0467 3.9553C15.0467 3.74533 14.9631 3.53428 14.7992 3.37358L11.6004 0.243214C11.4409 0.0878735 11.2253 2.57492e-05 10.9998 2.57492e-05C10.7754 2.57492e-05 10.5598 0.0878735 10.4003 0.243214Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabUpload);
export default __webpack_public_path__ + "static/media/tab-upload.a40617830e5fa7776a8a37728b4d7661.svg";
export { ForwardRef as ReactComponent };